import React, { useEffect, createContext, useState } from "react";


const ThemeContext = createContext(null);

// context theme
export default ThemeContext;